module.exports = __webpack_public_path__ + "static/media/TLC-SUSCRITOS-MEX.a5739d92.pdf";